/**
 * @param {string} d
 * @returns {string}
 */
export function color(d) {
  return d
}
